import angular from 'angular';
import * as Configuration from './../../app.constants.js';

export class FavoritesService {
  constructor($http, $q, $translate, $state, DropdownItemsFactory) {
    this.$http = $http;
    this.$q = $q;
    this.$translate = $translate;
    this.$state = $state;
    this.DropdownItemsFactory = DropdownItemsFactory;
  }

  // Favorite responses
  getFavorites(companyId) {
    return this.$http.get(`${Configuration.constants.baseUrl}api/1.0/companies/${companyId}/favorites`);
  }

  updateFavorites(companyId, favorites) {
    const items = [].concat(favorites).map(favorite => {
      const item = angular.copy(favorite);
      delete item.temporaryProperties;
      item.tags = favorite.tags.map(({ id, values }) => ({ id, values }));
      item.tags.forEach(({ id }) => {
        delete item[`tag-id-${id}`];
      });
      delete item.channelList;
      delete item.teamList;
      delete item.siteChannels;
      delete item.text;
      return item;
    });
    return this.$http.put(`${Configuration.constants.baseUrl}api/1.0/companies/${companyId}/favorites`, items);
  }


  // Helpers
  findTagItems(scope, tag) {
    return (scope.dropdownItems.tags || []).find(t => t.id === tag.id)?.items || [];
  }

  filterFavorites(favorites, filters) {
    const { active, channels, teams, sites, siteGroupIds } = filters;
    // when no sites are selected in the dropdown we should display all the sites on which the user has AUTOMATION right
    const tagFilters = Object.keys(filters)
      .filter(key => /tag-id-/.test(key));

    const assertTags = favorite =>
      tagFilters.reduce((matches, tagId) => {
        return matches && (!filters[tagId]?.length || !favorite[tagId].length || filters[tagId].some(value => favorite[tagId].some(id => id === value)))
      }, true);

    const hasTagFilters = tagFilters.reduce((matches, tagId) => matches || filters[tagId]?.length, false);
    const filteredFavorites = favorites.filter(favorite => {
      const hasFilter = active?.length || channels?.length || teams?.length || sites?.length || siteGroupIds?.length || hasTagFilters;
      return (
        !hasFilter ||
        (
          (!active?.length || active.some(value => favorite.active === value)) &&
          (!channels?.length || !favorite.channels.length || channels.some(value => favorite.channels.some(id => id === value))) &&
          (!teams?.length || !favorite.teams.length || teams.some(value => favorite.teams.some(id => id === value))) &&
          (!sites?.length || sites.some(value => favorite.sites.some(id => id === value))) &&
          (!siteGroupIds?.length || siteGroupIds.some(value => (favorite.siteGroupIds || []).some(id => id === value))) &&
          assertTags(favorite)
        )
      );
    });
    return filteredFavorites;
  }


  static FavoritesFactory($http, $q, $translate, $state, DropdownItemsFactory) {
    return new FavoritesService($http, $q, $translate, $state, DropdownItemsFactory);
  }
}

FavoritesService.FavoritesFactory.$inject = ['$http', '$q', '$translate', '$state', 'DropdownItemsFactory'];
